import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "accessibility-page-end d-print-none"
}
const _hoisted_2 = { class: "container-fluid container-xl" }
const _hoisted_3 = { class: "row g-0 accessibility-page-end__row" }
const _hoisted_4 = { class: "col-12 col-lg-11 g-0 accessibility-page-end__main" }
const _hoisted_5 = { class: "row g-0" }
const _hoisted_6 = { class: "col-12 col-lg-3 text-start accessibility-page-end__slot" }

import AccessibilityOptionsWidget from "@/components/AccessibilityOptions/AccessibilityOptionsWidget.vue";
import { useAccessibilityWidgetPlacement } from "@/composables/useAccessibilityWidgetPlacement";
import { isAccessibilityToolsEnabled } from "@/utils/accessibilityTools";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccessibilitySidebarActions',
  setup(__props) {

const accessibilityToolsEnabled = isAccessibilityToolsEnabled();
const { showInPageEnd } = useAccessibilityWidgetPlacement();

return (_ctx: any,_cache: any) => {
  return (_unref(accessibilityToolsEnabled) && _unref(showInPageEnd))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(AccessibilityOptionsWidget, { placement: "pageEnd" })
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})